
import { Component, Input } from "@angular/core"
import { MatButtonModule } from "@angular/material/button"
import { TranslatePipe } from "../../../i18n/pipes/translate.pipe"

@Component({
    selector: "app-scroll-bottom",
    templateUrl: "./scroll-bottom.component.html",
    styleUrls: ["./scroll-bottom.component.scss"],
    imports: [MatButtonModule, TranslatePipe]
})
export class ScrollBottomComponent {
  @Input() isVisible = true
  @Input() scrollableSelector = ".app-article"

  handleClick() {
    const body = document.querySelector(this.scrollableSelector)
    if (!body) {
      return
    }
    const behavior: ScrollBehavior = globalThis.matchMedia?.("(prefers-reduced-motion: reduce)").matches
      ? "auto" : "smooth"
    const container = body.closest<HTMLElement>(".app-wrapper")
    if (container) {
      container.scrollTo({ top: container.scrollHeight, behavior })
    } else {
      body.scrollIntoView({ behavior, block: "end" })
    }
  }
}
